module.exports = __webpack_public_path__ + "img/logo2.fff42553.png";